<template>
  <div class="home">
    <div class="col-sm">
      <transition-group>
      </transition-group>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
//  import LeftPanel from '@/components/LeftPanel.vue';
//  import HelloWorld from '@/components/HelloWorld.vue';
//  import HelloI18n from '@/components/HelloI18n.vue';
  import Helper from '@/helper/Helper';

  export default {
    name: 'Home',
    mounted() {
//      this.$router.push({name: "home"})
      const modul = this;
      modul.roles = [2, 3, 4, 5, 6, 7, 8, 9, 10];
      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
      if (!Helper.checkRoles(modul.roles, role)) {
        modul.$router.push({name: "dashboard"})
      }
    },
    components: {
//      LeftPanel,
//      HelloWorld,
//      HelloI18n,
    },
  };
</script>
